import {
  styled,
  Select as BaseSelect,
  Theme,
  InputLabel as BaseInputLabel,
  WithTheme,
  Typography,
} from '@material-ui/core'

interface InputLabelProps extends WithTheme {
  labelSize?: number
}

const SELECT_HEIGHT = 32
const SELECT_ICON_WIDTH = 25

export const Select = styled(BaseSelect)(
  ({
    theme,
    error,
    fullWidth,
  }: {
    theme: Theme
    error: boolean
    fullWidth?: boolean
  }) => ({
    height: SELECT_HEIGHT,
    width: fullWidth ? '100%' : 'max-content',
    paddingBottom: theme.spacing(0.1),
    '& svg': {
      color: error ? theme.palette.error.main : theme.palette.primary.main,
      transition: 'all .3s',
      width: SELECT_ICON_WIDTH,
    },
    '& .MuiPopover-root': {
      '& .MuiPaper-root': {
        '& .Mui-selected': {
          backgroundColor: theme.palette.common.white,
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
          },
        },
      },
    },
  })
)

export const InputLabel = styled(BaseInputLabel)(
  ({ theme, labelSize }: InputLabelProps) => ({
    marginBottom: theme.spacing(0),
    whiteSpace: 'nowrap',
    fontSize: labelSize || undefined,
  })
)

export const Placeholder = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.disabled,
}))
